import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-h5"
};
const _hoisted_2 = {
    key: 1,
    class: "text-h5"
};
import { computed, inject, onMounted, ref } from "vue";
import { createTimelineEvent, initTimelineEvent } from "@/model/TimelineEvent";
import { ProductServiceSymbol } from "@/InjectionSymbols";
import { LocalTime } from "@js-joda/core";
import { validationRules } from "@/ValidationRules";
import { Formatter } from "@/util/Formatter";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimelineTable',
    props: {
        productId: { type: Number, required: true },
        events: { type: Array, required: true },
        locations: {
            type: Array,
            required: true
        },
        timeslots: {
            type: Array,
            required: true
        }
    },
    emits: ['onEventUpdated'],
    setup(__props, { emit: __emit }) {
        const productService = inject(ProductServiceSymbol);
        const dialog = ref(false);
        const event = ref(createTimelineEvent());
        const eventTime = ref(new Date());
        const form = ref(null);
        const selectedTimeslot = ref(null);
        const props = __props;
        const emit = __emit;
        // Computed property to filter events based on selected timeslot
        const filteredEvents = computed(() => {
            if (!selectedTimeslot.value) {
                return props.events.filter(event => !event.timeslotId);
            }
            return props.events.filter(event => event.timeslotId === selectedTimeslot.value?.id);
        });
        onMounted(() => {
            eventTime.value.setSeconds(0);
        });
        function editEvent(item) {
            event.value = initTimelineEvent(createTimelineEvent(), item);
            eventTime.value.setHours(item.time.hour());
            eventTime.value.setMinutes(item.time.minute());
            dialog.value = true;
        }
        function closeDialog() {
            event.value = createTimelineEvent();
            dialog.value = false;
        }
        function onEventTimeUpdate(value) {
            event.value.time = LocalTime.parse(value.toLocaleTimeString());
        }
        function deleteEvent(item) {
            productService.deleteTimelineEvent(item.id)
                .then(() => {
                emit('onEventUpdated');
            });
        }
        function saveEvent() {
            if (selectedTimeslot.value) {
                event.value.timeslotId = selectedTimeslot.value.id;
            }
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    productService.saveTimelineEvent(props.productId, event.value)
                        .then(() => {
                        emit('onEventUpdated');
                        closeDialog();
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_vc_date_picker = _resolveComponent("vc-date-picker");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_container, { class: "pt-0" }, {
                default: _withCtx(() => [
                    (__props.timeslots.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_tabs, {
                            key: 0,
                            modelValue: selectedTimeslot.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedTimeslot).value = $event)),
                            "align-tabs": "start",
                            class: "mb-4",
                            "data-cy": "timeslotTabs"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_tab, { value: null }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode("Ohne Timeslot")
                                    ])),
                                    _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.timeslots, (timeslot) => {
                                    return (_openBlock(), _createBlock(_component_v_tab, {
                                        key: timeslot.id,
                                        value: timeslot,
                                        "data-cy": `timeslotTab-${timeslot.id}`
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(Formatter).timeslot(timeslot)), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["value", "data-cy"]));
                                }), 128))
                            ]),
                            _: 1
                        }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_data_table, {
                        "data-cy": "timetable",
                        items: filteredEvents.value,
                        "items-per-page": -1,
                        headers: [
                            { title: 'Tag', key: 'dayNumber' },
                            { title: 'Uhrzeit', key: 'time' },
                            { title: 'Ort', key: 'location' },
                            { title: 'Beschreibung', key: 'description' },
                            { title: '', key: 'actions' },
                        ]
                    }, {
                        [`header.actions`]: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                                modelValue: dialog.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((dialog).value = $event)),
                                "max-width": "500px"
                            }, {
                                activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_container, { class: "d-flex v-col-12 pa-0 ma-0 justify-center" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "createTimelineEvent" }), {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                            _createTextVNode("mdi-plus")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => [
                                                    (!event.value.id)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Neuer Eintrag"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Eintrag editieren"))
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_form, {
                                                        ref_key: "form",
                                                        ref: form
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_container, { class: "pa-0 d-flex flex-wrap" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_text_field, {
                                                                        class: "v-col-3",
                                                                        density: "compact",
                                                                        "hide-details": true,
                                                                        modelValue: event.value.dayNumber,
                                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((event.value.dayNumber) = $event)),
                                                                        label: "Tag",
                                                                        variant: "outlined",
                                                                        "data-cy": "dayNumber",
                                                                        rules: [_unref(validationRules).required]
                                                                    }, null, 8, ["modelValue", "rules"]),
                                                                    _createVNode(_component_v_spacer),
                                                                    _createVNode(_component_vc_date_picker, {
                                                                        class: "v-col-5 pa-0 mx-3 my-2",
                                                                        mode: "time",
                                                                        modelValue: eventTime.value,
                                                                        "hide-time-header": true,
                                                                        rules: { minutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55] },
                                                                        "onUpdate:modelValue": onEventTimeUpdate,
                                                                        is24hr: true
                                                                    }, null, 8, ["modelValue"]),
                                                                    _createVNode(_component_v_select, {
                                                                        class: "v-col-12",
                                                                        density: "compact",
                                                                        modelValue: event.value.location,
                                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((event.value.location) = $event)),
                                                                        items: __props.locations,
                                                                        "item-title": "name",
                                                                        label: "Ort",
                                                                        variant: "outlined",
                                                                        "return-object": "",
                                                                        "data-cy": "eventLocation",
                                                                        "hide-details": true
                                                                    }, null, 8, ["modelValue", "items"]),
                                                                    _createVNode(_component_v_textarea, {
                                                                        class: "v-col-12",
                                                                        density: "compact",
                                                                        modelValue: event.value.description,
                                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((event.value.description) = $event)),
                                                                        label: "Beschreibung",
                                                                        variant: "outlined",
                                                                        "data-cy": "eventDescription",
                                                                        rules: [_unref(validationRules).maxLength(255)],
                                                                        rows: "1",
                                                                        "auto-grow": ""
                                                                    }, null, 8, ["modelValue", "rules"])
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 512)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                        variant: "text",
                                                        onClick: closeDialog
                                                    }, {
                                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                            _createTextVNode(" Cancel ")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_btn, {
                                                        variant: "text",
                                                        onClick: saveEvent,
                                                        "data-cy": "saveTimelineEvent"
                                                    }, {
                                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                            _createTextVNode(" Save ")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ]),
                        [`item.location`]: _withCtx(({ item }) => [
                            (item.location)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item.location.name), 1)
                                ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        [`item.actions`]: _withCtx(({ item }) => [
                            _createVNode(_component_v_icon, {
                                "data-cy": "editTimelineEvent",
                                class: "me-2",
                                color: "info",
                                size: "small",
                                onClick: ($event) => (editEvent(item))
                            }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode(" mdi-pencil ")
                                ])),
                                _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_icon, {
                                "data-cy": "deleteTimelineEvent",
                                size: "small",
                                color: "error",
                                onClick: ($event) => (deleteEvent(item))
                            }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createTextVNode(" mdi-delete ")
                                ])),
                                _: 2
                            }, 1032, ["onClick"])
                        ]),
                        bottom: _withCtx(({}) => _cache[11] || (_cache[11] = [])),
                        _: 2
                    }, 1032, ["items"])
                ]),
                _: 1
            }));
        };
    }
});
